import React from 'react';
import { Connect, PropsFromRedux } from './CategoriesContainer';
import { searchConstants } from '../../../search-utils/searchConstants';
import { CommonSection } from '../CommonSection';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { checkIfCategoryIsSelected } from './categoriesUtils';
import { CategoriesNode } from './CategoriesNode';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';
import { CategoryEnum, CategoryType } from '../../../search.types';

type OwnProps = {
  type: CategoryEnum;
};

type Props = PropsFromRedux &
  OwnProps &
  WithRestrictedModalProps &
  UserContextType;

type State = {
  panes: { [s: string]: boolean };
};

export class RawCategories extends React.Component<Props, State> {
  state: State = {
    panes: {},
  };

  togglePane = (path: Array<string>) => () => {
    const key = path[path.length - 1];
    const isSelected = this.state.panes[key];
    doctrineAnalytics('Search SeeMoreFilterClicked', {
      type: isSelected ? 'see-less' : 'see-more',
      ...this.getPathFormated(path),
    });

    this.setState(({ panes }) => ({
      panes: {
        ...panes,
        [key]: !panes[key],
      },
    }));
  };

  toggleCategory = (subPath: Array<string>, category: CategoryType) => () => {
    const {
      aggregationsPaths,
      accessPremium,
      toggleAggregation,
      openRestrictedModal,
    } = this.props;

    if (!accessPremium) {
      return openRestrictedModal('faceted-item');
    }

    const path = subPath.concat(category.key);
    const isSelected = !checkIfCategoryIsSelected(path, aggregationsPaths);

    if (isSelected) {
      doctrineAnalytics('Search FilterCategoryClicked', {
        ...this.getPathFormated(path),
      });
    }

    return toggleAggregation(path, isSelected);
  };

  getPathFormated = (path: Array<string>) => {
    const dataKeys = [
      'aggregation_name',
      'category',
      'sub_category',
      'sub_sub_category',
    ];
    const reducer = (
      acc: { [s: string]: string },
      key: string,
      index: number,
    ) => ({
      ...acc,
      [dataKeys[index]]: key,
    });
    return path.reduce(reducer, {
      search_type: this.props.searchType,
    });
  };

  render() {
    const { type, categories, aggregationsPaths } = this.props;
    const { panes } = this.state;
    return (
      <CommonSection title={searchConstants.filters[type]}>
        <>
          <CategoriesNode
            level={0}
            handleClick={this.toggleCategory}
            togglePane={this.togglePane}
            items={categories}
            path={[type]}
            panes={panes}
            aggregationsPaths={aggregationsPaths}
            customClass="search-filters-categories__root"
          >
            {category => (
              <CategoriesNode
                level={1}
                customClass="search-filters-categories__sub-wrapper"
                handleClick={this.toggleCategory}
                togglePane={this.togglePane}
                items={category.sub}
                path={[type, category.key]}
                panes={panes}
                aggregationsPaths={aggregationsPaths}
              >
                {subCategory => (
                  <CategoriesNode
                    level={2}
                    customClass="search-filters-categories__sub-sub-wrapper"
                    handleClick={this.toggleCategory}
                    togglePane={this.togglePane}
                    items={subCategory.sub}
                    path={[type, category.key, subCategory.key]}
                    panes={panes}
                    aggregationsPaths={aggregationsPaths}
                  />
                )}
              </CategoriesNode>
            )}
          </CategoriesNode>
        </>
      </CommonSection>
    );
  }
}

export const Categories = Connect(withUser(withRestrictedModal(RawCategories)));
